module.exports = __webpack_public_path__ + "img/about_7.962a0640.png";